<div class="grouped-reservations-detail-component">
  <mat-toolbar [ngStyle]="{ background: '#009ADE' }">
    <div class="ws-popup-header">
      <div class="reservation-title" *ngIf="reservation">
        <span>{{ getExperienceName(reservation) }}</span>
        <span *ngIf="availability">
          - {{ "Available seats" | translate }}:
          {{ availability.availableSeats > 0 ? availability.availableSeats : 0 }} (
          {{ availability.occupiedCount }}/{{ availability.maxParties }} )</span>
        <span [ngClass]="{ 'grey': getCheckedInCount() == 0,
                            'yellow': getCheckedInCount() < getTotalReservationsCount(),
                            'green': getCheckedInCount() == getTotalReservationsCount()
                          }" class="seatsLabel" *ngIf="getTotalReservationsCount() > 0">{{ "Check-in" | translate }}:
          {{ getCheckedInCount() }} / {{
          getTotalReservationsCount()
          }} {{ "guests" | translate }}
        </span>
      </div>
      <div class="actions">
          <ws-actions
                  (clickOnAction)="onActionClicked($event)"
                  *ngIf="reservation"
                  [icon]="'more_vert'"
                  [options]="actionOptions"
                  class="actions-wrapper-ws-button">
          </ws-actions>
        <button mat-icon-button (click)="cancelClicked()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  </mat-toolbar>


  <div class="content-wrapper" *ngIf="reservation">
    <div class="content-row">
      <mat-grid-list cols="1" rowHeight="40px" class="reservation-information">
        <mat-grid-tile>
          <div class="field-wrapperlt">
            <mat-icon class="matIconForLabel">event_note</mat-icon>
            <label class="wrapperltLabelforValue">{{
              displayDate(
              moment(reservation.date + "T" + reservation.time).toDate()
              )
              }}</label>
          </div>
        </mat-grid-tile>
        <mat-grid-tile *ngIf="!multiLanguage">
          <div class="field-wrapperlt">
            <mat-icon class="matIconForLabel">language</mat-icon>
            <label class="wrapperltLabelforLabel">{{ "Language" | translate }}:
            </label>
            <div class="language-wrapper">
              <ws-flag *ngIf="reservation.languageIso" [countryCode]="getCountryCodeForLanguage(reservation.languageIso)"
                [showBorder]="true" size="small">
              </ws-flag>
              <label class="wrapperltLabelforValue">{{
                reservation.languageIso
                ? ("lang_" + reservation.languageIso | translate)
                : ""
                }}</label>
            </div>
          </div>
        </mat-grid-tile>
        <mat-grid-tile *ngIf="reservation.roomId">
          <div class="field-wrapperlt">
            <mat-icon class="matIconForLabel">sensor_door</mat-icon>
            <label class="wrapperltLabelforLabel">{{ "Room" | translate }}:
            </label>
            <label class="wrapperltLabelforValue">{{
              roomName(reservation.roomId) | truncate : [30, "..."]
              }}</label>
          </div>
        </mat-grid-tile>
        <mat-grid-tile *ngIf="reservation.employeeId">
          <div class="field-wrapperlt">
            <mat-icon class="matIconForLabel">person</mat-icon>
            <label class="wrapperltLabelforLabel">{{ "Employee" | translate }}:
            </label>
            <label class="wrapperltLabelforValue">{{
              employeeName(reservation.employeeId) | truncate : [30, "..."]
              }}</label>
          </div>
        </mat-grid-tile>
        <mat-grid-tile>
          <div class="field-wrapperlt">
            <mat-icon class="matIconForLabel">euro</mat-icon>
            <label class="wrapperltLabelforLabel">{{ "Total" | translate }}:
            </label>
            <label class="wrapperltLabelforValue">{{
              formatTotal(reservation.netTotalCents || 0)
              }}</label>
          </div>
        </mat-grid-tile>
      </mat-grid-list>
      <mat-grid-list cols="1" rowHeight="40px" class="reservation-information">
        <mat-grid-tile>
          <div class="field-wrapperlt">
            <img alt="conversion" class="imageIconForLabel" src="assets/icons/icon-price-e-filled.png" />
            <label class="wrapperltLabelforLabel">{{
              (reservation
              ? getLabel1Title(reservation)
              : ("Price 1" | translate)
              ) | truncate : [20, "..."]
              }}:
            </label>
            <label class="wrapperltLabelforValue">{{
              reservation.guestCount01
              }}</label>
          </div>
        </mat-grid-tile>
        <div *ngFor="let priceLabel of reservationPriceLabelsExcludeFirstIfPresent">
          <mat-grid-tile *ngIf="priceLabel.quantity > 0">
            <div class="field-wrapperlt">
              <img alt="conversion" class="imageIconForLabel" src="assets/icons/icon-price-e-filled.png" />
              <label class="wrapperltLabelforLabel">
                {{ priceLabel?.title_translations?.it | truncate : [20, "..."] }}:
              </label>
              <label class="wrapperltLabelforValue">{{
                priceLabel.quantity
                }}</label>
            </div>
          </mat-grid-tile>
        </div>
        <div *ngFor="let priceExtra of reservation.reservationPriceExtras">
          <mat-grid-tile *ngIf="priceExtra.quantity > 0">
            <div class="field-wrapperlt">
              <img alt="conversion" class="imageIconForLabel" src="assets/icons/icon-price-e.png" />
              <label *ngIf="priceExtra?.title_translations" class="wrapperltLabelforLabel">
                {{
                priceExtra?.title_translations[language] | truncate : [20, "..."]
                }}:
              </label>
              <label class="wrapperltLabelforValue">{{
                priceExtra.quantity
                }}</label>
            </div>
          </mat-grid-tile>
        </div>
      </mat-grid-list>
    </div>
    <mat-divider></mat-divider>
    <div class="content-row containerReservationViews" style="height: auto">
      <mat-grid-list cols="1" rowHeight="285px" style="width: 100%">
        <mat-grid-tile *ngFor="let reserv of reservation.optionalData?.childEvents">
          <grouped-calendar-single-reservation (detailsClick)="onClickDetails(reserv)" [employees]="employees"
            [reservation]="reserv" [rooms]="rooms" [multiLanguage]="multiLanguage"
            style="width: 100%; height: 100%"></grouped-calendar-single-reservation>
        </mat-grid-tile>
      </mat-grid-list>
    </div>
  </div>

  <reservation-pdf-exporter #exporterPDF></reservation-pdf-exporter>
</div>